module.exports = __webpack_public_path__ + "img/JA.b511e4df.png";